import gql from 'graphql-tag'

export const getAccountContact = gql`
  query($accountContactId: Int!) {
    getAccountContact(
      accountContactId: $accountContactId
    ) {
      id
      roles
      createdAt
      updatedAt
      lastModifiedBy {
        id
        username
      }
      createdBy {
        id
        username
      }
      account {
        id
        name
      }
      contact {
        id
        name
      }
    }
  }
`

export const createAccountContact = gql`
  mutation($accountContactInput: AccountContactInput!) {
    createAccountContact(
      accountContactInput: $accountContactInput
    )
  }
`

export const editAccountContactRoles = gql`
  mutation($roles: [AccountContactRelationRole!], $accountContactId: Int!) {
    editAccountContactRoles(
      roles: $roles,
      accountContactId: $accountContactId
    ) {
      id
      roles
      createdAt
      updatedAt
      lastModifiedBy {
        id
        username
      }
      createdBy {
        id
        username
      }
      account {
        id
        name
      }
      contact {
        id
        name
      }
    }
  }
`

export const removeAccountContact = gql`
  mutation($accountContactId: Int!) {
    removeAccountContact(
      accountContactId: $accountContactId
    )
  }
`
